import React from 'react';
import DataResource from '../../common/v4/DataResource'
import Panel from '../../common/layout/Panel'

export default class extends React.Component {
    render(){
        const data = {
            url: '/admin/clients/clients',
            data: {
                data: [],
                metadata: []
            },
            userFilterExpandable: false,
            userFilterSimple: true,
            userfilter:
                [
                    {
                        source: 'ATRCLIENTIDNUMBER',
                        label: 'Client ID',
                        type: 'text',
                        default: ''
                    },
                    {
                        source: 'ATRACCTNAME',
                        label: 'Name',
                        type: 'text',
                        default: ''
                    }
                ],
            onclick: 'link',
            link: '/clients/clients/{id}/edit',
            metadata:
                [
                    {
                        label: 'id',
                        source: 'ATRCLIENTID',
                        type: 'primary',
                        editable: false,
                        visible: false
                    },
                    {
                        label: 'Client ID',
                        source: 'ATRCLIENTIDNUMBER',
                        type: 'text',
                        editable: true,
                        visible: true,
                        placeholder: 'ID'
                    },
                    {
                        label: 'Name',
                        source: 'ATRACCTNAME',
                        type: 'text',
                        editable: true,
                        visible: true,
                        placeholder: 'Name'
                    },
                    {
                        label: 'Company Name',
                        source: 'ATRNAME',
                        type: 'text',
                        editable: true,
                        visible: true,
                        placeholder: 'Company'
                    },
                    {
                        label: 'Currency',
                        source: 'ATRCURID',
                        type: 'select',
                        editable: false,
                        visible: true,
                        default: '1'
                    },
                    {
                        label: 'Balance',
                        source: 'ATRBALANCE',
                        type: 'money',
                        editable: false,
                        visible: true,
                        default: '0.00'
                    },
                    {
                        label: 'Credit Limit',
                        source: 'ATRCREDLIM',
                        type: 'money',
                        editable: true,
                        visible: true,
                        default: '0.00',
                        placeholder: '0.00'
                    },
                    { label: 'Reseller',
                        source: 'ATRRESELLERID',
                        type: 'select',
                        editable: true,
                        visible: true,
                        default: '0'
                    },
                    {
                        label: 'Rate Profile',
                        source: 'ATRPRODUCTID',
                        type: 'select',
                        editable: true,
                        visible: true,
                        default: '0'
                    },
                    {
                        label: 'Payment Terms',
                        source: 'payment_term_id',
                        type: 'select',
                        editable: true,
                        visible: true,
                        default: '0'
                    },
                    {
                        label: 'Enabled',
                        source: 'ATRSTATUS',
                        type: 'boolean',
                        editable: true,
                        visible: true,
                        default : true
                    },{
                        label: 'Delete',
                        type: 'delete'
                    }
                ]
            };     
        return (
            <Panel title = "Clients">
                <DataResource
                    addButtonText = "Create Client"  
                    addButtonLink = "/clients/clients/add"
                    data = {data}
                    {...this.props}
                    pagination
                />
            </Panel>
        )
    }
}
